/*
 * @format
 */
import React, { Component } from 'react';
import AdditionalLinks from './AdditionalLinks'

export default class RightRail extends Component {
    render() {
        if (!this.props.rightRail) {
            return null;
        }

        const { title = '', body = null, links } = this.props.rightRail;

        return (
            <div className="rec-venue-page-right-rail">
                <aside>
                    <div className="rec-aside-header">
                        <div>{title}</div>
                    </div>
                    <div className="rec-aside-body">
                        {body}
                    </div>

                    <AdditionalLinks links={links} />
                </aside>
            </div>
        );
    }
}
